// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".menu-delimeter{color:#cacdd9;font-size:14px;width:100%;display:flex;margin-top:16px;align-items:center}.menu-delimeter__title{margin-right:8px;flex-shrink:unset;white-space:nowrap;line-height:1.4}.menu-delimeter__line{height:1px;width:100%;background-color:#cacdd9}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
